<template>
  <section class="content-block ie-fix">
    <transition name="slide-fade">
      <div
        v-if="active && $store.state.edit_slots"
        class="block has-white-background"
      >
        <div class="inner-block is-flex">
          <div class="col-2">
            <h1 class="title">
              {{ $t("editView.label.bookedTour") }}
            </h1>

            <h1
              v-for="seqId in Object.keys($store.state.edit_slots)"
              class="adj-height reset"
            >
              <strong>{{ $t("sequenceLabels.tour." + seqId) }}:</strong>
              <span class="font-weight-adj"> {{
                $t('datenView.label.formattedDate', {
                  date: selectedDate,
                  time: $store.state.edit_slots[seqId].time
                })
              }}</span>
            </h1>

            <h1>
              <strong>{{ $t("fahrtView.label.amountOfGuests") }}:</strong>
              <span class="font-weight-adj"> {{ $store.state.edit_qty }}</span>
            </h1>
          </div>
          <div class="col-2 has-mobile-adj">
            <a
              class="button control has-icons-right is-outlined is-primary"
              @click="fetch_DELETE_Fn()"
            >{{ $t("editView.button.cancelReservation") }}</a>
          </div>
        </div>
      </div>
    </transition>

    <transition name="slide-fade">
      <div
        v-if="active && $store.state.edit_slots"
        class="block has-white-background"
      >
        <div class="inner-block is-flex">
          <div class="col-2">
            <h1 class="title">
              {{ $t("general.label.date") }}
            </h1>
            <p
              v-scroll-to="'#datepicker'"
              class="control has-icons-right"
              id="datepicker"
            >
              <datepicker
                :placeholder="$t('general.label.selectDate')"
                :input-class="'input'"
                :minimum-view="minimumView"
                :maximum-view="maximumView"
                :format="format"
                :language="language"
                :full-month-name="true"
                :monday-first="true"
                v-model="$store.state.edit_date"
                :disabled-dates="disabledDates"
                @input="fetch_GET_Fn()"
              />
              <span class="icon is-small is-right">
                <font-awesome-icon icon="calendar-alt" />
              </span>
            </p>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import {liveURL} from '../../api-config';
import moment from 'moment'
import axios from 'axios'

import Datepicker from 'vuejs-datepicker';
import {de} from 'vuejs-datepicker/dist/locale';
import {en} from 'vuejs-datepicker/dist/locale';

export default {
  name: 'FahrtAuswahl',
  components: {
    Datepicker
  },
  data() {
    return {
      active: false,
      format: 'dd. MMMM yyyy',
      minimumView: 'day',
      maximumView: 'day',
      selectedDate: moment(this.$store.state.edit_date).format('DD.MM.YYYY'),
      language: this.$t('general.settings.currentLanguageCode') === 'de' ? de : en,        // Todo: Find better way to get languageObject :)
      disabledDates: {
        to: new Date(Date.now())
      },
    }
  },
  computed: {
    ticket_reservation: {
      get() {
        return this.$store.state.ticket_reservation_amount
      },
      set(value) {
        this.$store.state.ticket_reservation_amount = value
      }
    }
  },
  mounted() {
    this.active = true

    if (!this.$store.state.edit_slots[4]) {
      this.$store.state.fahrttyp = 'default';
      this.format = 'dd. MMMM yyyy';
      this.minimumView = 'day';
      this.maximumView = 'day';
    } else {
      this.$store.state.fahrttyp = 'subset';
      this.format = 'MMMM yyyy';
      this.minimumView = 'month';
      this.maximumView = 'month';
    }

    this.fetch_GET_Fn()
  },
  methods: {
    fetch_GET_Fn() {
      this.$store.state.isLoading = true
      const sequenceSets = {
        1: 'Bergfahrt',
        3: 'Talfahrt',
      }
      for (const seqId in this.$store.state.edit_slots) {
        const time1 = seqId > 3
          ? moment(this.$store.state.edit_date).startOf('month').format('YYYY-MM-DD')
          : moment(this.$store.state.edit_date).format('YYYY-MM-DD');

        const time2 = seqId > 3
          ? moment(this.$store.state.edit_date).endOf('month').add(1, 'days').format('YYYY-MM-DD')
          : moment(this.$store.state.edit_date).add(1, 'days').format('YYYY-MM-DD');
        const time2key = seqId > 3 ? 'startTime' : 'endTime';
        const url = liveURL + `/api/ticket/slot?eventSequenceId=${seqId}&q=gt(startTime,${time1})lt(${time2key},${time2})`;
        axios.get(url, {})
          .then(function (response) {
            this.$store.state[`fetch_GET_Content_${sequenceSets[seqId] ? sequenceSets[seqId] : 'subset'}`] = response.data;
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
      }

      this.$store.state.isLoading = false;
    },
    fetch_DELETE_Fn() {
      this.$store.state.isModal_DeleteCurrentReservationActive = true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
